import { render } from "./loan-details.vue?vue&type=template&id=1c711dac&scoped=true"
import script from "./loan-details.vue?vue&type=script&lang=js"
export * from "./loan-details.vue?vue&type=script&lang=js"

import "./loan-details.vue?vue&type=style&index=0&id=1c711dac&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src4154090898/src/platform-insurance-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c711dac"]])

export default __exports__